<template>
  <div class="base-chips">
    {{label}}
    <div @click.stop="$emit('click')" class="base-chips__cross"></div>
  </div>
</template>

<script>
export default {
  name: 'BaseChips',
  props: {
    label: {
      type: String,
      require: true
    }
  }
}
</script>

<style scoped lang="scss">
.base-chips {
  font-size: 12px;
  border: 1px solid #e6e6e6;
  margin-top: 15px;
  border-radius: 20px;
  color: $rfx-dark-grey;
  line-height: 30px;
  padding: 3px 12px;
  display: inline-block;

  &__cross {
    display: inline-block;
    position: relative;
    width: 18px;
    height: 10px;
    border-radius: 50%;
    cursor: pointer;

      &:before,
      &:after {
        position: absolute;
        right: 7px;
        content: " ";
        top: -3px;
        height: 17px;
        width: 2px;
        background-color: $rfx-silver;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }

      &:hover {
        &:before, &:after {
          background-color: $rfx-bright-blue;
        }
      }
  }
}
</style>
